import {
    NinchatActionType,
    NinchatDescribeQueueTranscriptsAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatQueueTranscriptsFoundEvent} from '../types/events'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const describeQueueTranscripts = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDescribeQueueTranscriptsAction}`,
    async (arg: NinchatActionParams<NinchatDescribeQueueTranscriptsAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDescribeQueueTranscriptsAction

        try {
            return await ninchatClient.send(params) as NinchatQueueTranscriptsFoundEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
